import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import { colors } from '@src/common/styles/valueTokens';

type Props = {
  title: string;
  subtitle?: string;
  id?: string;
  rightBlock?: React.ReactNode;
  children?: React.ReactNode;
  style?: object;
};

export const PageLayout = ({
  title,
  subtitle,
  id,
  rightBlock,
  children,
  style,
}: Props) => {
  return (
    <Stack
      direction="column"
      margin="40px"
      style={{ gap: theme.spacing['4'], ...style }}
    >
      <Stack direction="column">
        <Header title={title} rightBlock={rightBlock} id={id} />
        {subtitle && (
          <Typography style={{ color: colors.text.secondary }}>
            {subtitle}
          </Typography>
        )}
      </Stack>
      {children}
    </Stack>
  );
};

type HeaderProps = {
  title: string;
  id?: string;
  rightBlock?: React.ReactNode;
};

export const Header = ({ title, id, rightBlock }: HeaderProps) => {
  return (
    <Stack
      direction="row"
      gap="24px"
      alignItems="center"
      justifyContent="space-between"
    >
      <Typography className={titleFont} component="h1" variant="h3" id={id}>
        {title}
      </Typography>
      {rightBlock}
    </Stack>
  );
};

const titleFont = css(() => ({
  fontSize: '33px',
  fontWeight: 600,
}));
